(function() {
    let tlFreeGiftOfferClone;
    let popupWidgetClone;
    let embedWidgetClone;

    const showEmbedWidget = () => {
        const embedWidgetContainers = document.querySelectorAll('.salepify-embed-widget__container');
        embedWidgetContainers.forEach(el => {
            el.style.display = "flex";
        })
    }

    Object.defineProperty(window, "tlFreeGiftOffer", {
        get() {
            return tlFreeGiftOfferClone;
        },
        set(val) {
            if (val && !tlFreeGiftOfferClone) {
                val.cartHasChanged = true;
                val.updateCartData = async () => {
                    try {
                        await window.tlFreeGiftOffer.detectCartData();

                        const { isUpdateCart, eligibleOtherRules } = await window.tlFreeGiftOffer.checkAllRule();
                        showEmbedWidget(); // add this fuction
                        if(isUpdateCart){
                            // Prevent Reload
                            await window.tlFreeGiftOffer.refreshCartContent();
                        }else {
                            // Render
                            window.tlFreeGiftOffer.showPopupOffer(eligibleOtherRules)
                            window.tlFreeGiftOffer.showEmbedOffer();
                        }
                    } catch (error) {
                        console.log("Error when checkCartData: ", error);
                    }
                }
                tlFreeGiftOfferClone = val;

                Object.defineProperty(val, "popupWidget", {
                    get() {
                        return popupWidgetClone;
                    },
                    set(newValue) {
                        if (!newValue || popupWidgetClone) return;

                        newValue.showOffer = ({rule, canClaimCount, bogoItem }) => {
                            const { id: ruleId } = rule;
                    
                            // Get translation of current render rule
                            const translation = window.tlFreeGiftOffer.popupWidget.getRuleTranslation(rule);
                            window.tlFreeGiftOffer.popupWidget.syncFixedQtyGiftAdded(rule);

                            window.tlFreeGiftOffer.popupWidget.headerElement.querySelector(".salepify-popup-header__title").innerHTML = translation.title;
                            window.tlFreeGiftOffer.popupWidget.headerElement.querySelector(".salepify-popup-header__subtitle").innerHTML = translation.subtitle;

                            const totalGift = window.tlFreeGiftOffer.popupWidget.getTotalGift(rule)

                            window.tlFreeGiftOffer.popupWidget.bodyElement.innerHTML = `
                                <div class="salepify-popup__countdown-timer">${window.tlFreeGiftOffer.popupWidget.getCountDownTimerContent(rule, translation.countdown_timer)}</div>

                                <div class="salepify-popup__reward-selection">
                                    ${bogoItem ? "" : window.tlFreeGiftOffer.popupWidget.handleReplaceVariable(rule, translation.reward_selection)}
                                </div>

                                <div class="salepify-popup__item-container-wrapper">
                                    <div ${window.tlFreeGiftOffer.popupWidget.requiredAttr} rule-id="${ruleId}" 
                                        class="salepify-popup__gift-container salepify-popup__item-container"
                                        ${bogoItem ? "" : `onscroll='window.tlFreeGiftOffer.popupWidget.handleScrollListGifts(window.tlFreeGiftOffer.popupWidget, ${ruleId})'`}
                                    >
                                        ${bogoItem ? window.tlFreeGiftOffer.popupWidget.renderGifts(rule, [bogoItem.itemData], bogoItem.claimTimes) : ""}
                                    </div>
                                </div>

                                <div class="salepify-popup__footer">
                                    <div class="salepify-popup__dismiss-toggle">
                                        <label class="salepify-popup__switch">
                                            <input type="checkbox" onChange="window.tlFreeGiftOffer.popupWidget.handleDismiss(${ruleId})"/>
                                            <span class="salepify-popup__slider" />
                                        </label>
                                        <span class="salepify-popup__dismiss-help-text">${translation.dismiss_help_text}</span>
                                    </div>
                                    
                                    <div class="salepify-flex-wrap-claim-button">
                                        <div class="salepify-no-thanks"
                                            onclick='window.tlFreeGiftOffer.popupWidget.handleDismiss(${ruleId}); window.tlFreeGiftOffer.popupWidget.hideModal()'
                                        >
                                            No thanks
                                        </div>
                                        <div class="salepify-popup__claim-button" rule-id="${ruleId}"
                                            onclick='${bogoItem 
                                                ? `window.tlFreeGiftOffer.popupWidget.handleClaimBogoGift(${ruleId} , ${bogoItem.itemData.id}, ${bogoItem.claimTimes})`
                                                : `window.tlFreeGiftOffer.popupWidget.handleClaimGift(${ruleId})`
                                            }'
                                        >
                                            ${translation.claim_btn}
                                            ${bogoItem ? "" : `(${window.tlFreeGiftOffer.popupWidget.getDisplayedGiftCount(rule, totalGift)}/${totalGift})`}
                                        </div>
                                    </div>
                                </div>

                                <div id="salepify-popup-error-${ruleId}">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512">
                                        <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                                    </svg>
                                    <span class="salepify-popup-error__message"></span>
                                </div>
                            `;        
                            if(!bogoItem){
                                window.tlFreeGiftOffer.popupWidget.firstLoadingGifts(rule, canClaimCount)
                                window.tlFreeGiftOffer.popupWidget.bodyElement.classList.remove("salepify-popup-offer--bogo")
                            }else {
                                window.tlFreeGiftOffer.popupWidget.bodyElement.classList.add("salepify-popup-offer--bogo")
                            }
                            window.tlFreeGiftOffer.popupWidget.showModal();
                        }

                        popupWidgetClone = newValue;
                    },
                    configurable: true
                });

                Object.defineProperty(val, "embedWidget", {
                    get() {
                        return embedWidgetClone;
                    },
                    set(newValue) {
                        if (!newValue || embedWidgetClone) return;

                        newValue.checkIfPopupEnabled = (ruleId) => {
                            return false;
                        }

                        embedWidgetClone = newValue
                    },
                    configurable: true
                })
            }
        },
        configurable: true
    });
})();

// progress bar custom
const reRenderCartGoalEmbed = () => {
    const cartGoalContainer = document.querySelector(".tl-custom-cart-goal-container");
    if (cartGoalContainer) {
        return;
    } else {
        window.tlCartGoalEmbed.renderAllCartGoals();
    }
}

const cartDrawerTriggerBtn = document.querySelectorAll(".header__cart-links--cart");
if (cartDrawerTriggerBtn.length > 0) {
    cartDrawerTriggerBtn.forEach(el => {
        el.addEventListener("click", function () {
            setTimeout(reRenderCartGoalEmbed, 1000);
        })
    })
}